import { useEffect } from "react";
import Button from "../../student/components/generic/button";
import { CopyToClipboardButton } from "../../manager/components/Experiment/CopyToClipboardButton";
import { useDMQuery } from "../../utils";
import { IntegrationInfoType } from "./IntegrationLanding";
import NonSuperAdminCredentials from "./NonSuperAdminCredentials";

type Props = {
  integration: IntegrationInfoType;
  lti_credentials?: {
    key: string;
    secret: string;
  };
};

const Integration11 = (props: Props) => {
  return (
    <div className="bg-dm-background-blue-100 p-6">
      <div className="rounded-lg border-b border-dm-charcoal-100 bg-white p-6">
        <div className="border-b border-dm-charcoal-100 pb-4">
          <h3 className="font-medium leading-6 text-dm-gray-800">
            Integration Guide
          </h3>
          <Button type="outline" className="my-4">
            {props.integration.title} LTI 1.1 Guide{" "}
            <i className="far fa-external-link-alt ml-2"></i>
          </Button>
        </div>
        <div className="my-6 flex flex-col gap-1 border-b border-dm-charcoal-100 pb-4">
          <h3 className="mb-3 font-medium leading-6 text-dm-gray-800">
            LTI Integration Credentials
          </h3>
          {props.lti_credentials ? (
            <>
              <h4 className="font-sm font-bold leading-6 text-dm-gray-800">
                Key
              </h4>
              <p className="text-sm text-dm-gray-800">
                {props.lti_credentials?.key}{" "}
                {props.lti_credentials?.key && (
                  <CopyToClipboardButton
                    value={props.lti_credentials?.key}
                    className="ml-2"
                  />
                )}
              </p>
              <h4 className="font-sm mt-4 font-bold leading-6 text-dm-gray-800">
                Secret
              </h4>
              <p className="text-sm text-dm-gray-800">
                {props.lti_credentials?.secret}{" "}
                {props.lti_credentials?.secret && (
                  <CopyToClipboardButton
                    value={props.lti_credentials?.secret}
                    className="ml-2"
                  />
                )}
              </p>
            </>
          ) : (
            <NonSuperAdminCredentials />
          )}
        </div>
        <div className="my-6 flex flex-col gap-1 border-b border-dm-charcoal-100 pb-4">
          <h3 className="mb-3 font-medium leading-6 text-dm-gray-800">
            Helpful Links
          </h3>
          <Button
            href="https://help.deltamath.com/"
            target="_blank"
            type="link"
          >
            This is a help center link
          </Button>
          <Button
            href="https://help.deltamath.com/"
            target="_blank"
            type="link"
          >
            This is a help center link
          </Button>
          <Button
            href="https://help.deltamath.com/"
            target="_blank"
            type="link"
          >
            This is a help center link
          </Button>
          <Button
            href="https://help.deltamath.com/"
            target="_blank"
            type="link"
          >
            This is a help center link
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Integration11;
